import './styles.css'
import {useSelector} from "react-redux";
import {getLanguage} from "../../../../components/LanguageModal/reducer";
import translations from "../../../../components/LanguageModal/translations";

const CardOrganizer = (props) => {
    const {
        id = 0,
        initiator = {},
        respondent = {},
        meeting = {},
        placement = '',
        on_date = '',
        on_time = '',
        expo_event = '',
        name = '',
        onOpen = () => {},
    } = props

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    return (
        <div className='org-card'>
            <h2 className='org-card-title'>{name}</h2>
            <div className='org-card-columns'>
                <div className='org-card-column'>
                    <div className='org-card-name'>{t('initiator')}:</div>
                    <div className='org-card-name'>{t('company')}:</div>
                    <div className='org-card-name'>{t('matchmaker')}:</div>
                    <div className='org-card-name'>{t('placementMeeting')}:</div>
                    <div className='org-card-name'>{t('timeMeeting')}:</div>
                    <div className='org-card-name'>{t('dateMeeting')}:</div>
                    <div className='org-card-name'>{t('meetingStatus')}:</div>
                </div>
                <div className='org-card-column'>
                    <div className='org-card-value'>
                        {
                            (languageString === 'ru' ?
                                initiator.initiator_exponent_name
                                :
                                initiator.initiator_user_name_en)
                        }
                    </div>
                    <div className='org-card-value'>
                        {
                            languageString === 'ru' ?
                                respondent.respondent_exponent_name
                                :
                                respondent.respondent_exponent_name_en
                        }
                    </div>
                    <div className='org-card-value'>
                        {
                            languageString === 'ru' ?
                                respondent.respondent_user_name
                                :
                                respondent.respondent_user_name_en
                        }
                    </div>
                    <div className='org-card-value'>
                        {
                            placement
                        }
                    </div>
                    <div className='org-card-value'>
                        {
                            on_time
                        }
                    </div>
                    <div className='org-card-value'>
                        {
                            on_date.split('-').reverse().join('.')
                        }
                    </div>
                    <div className='org-card-value'>
                        {
                            languageString === 'ru' ?
                                meeting.meeting_status_name
                                :
                                meeting.meeting_status_name_en
                        }
                    </div>
                </div>
            </div>
            <button className='org-card-btn' onClick={() => onOpen(id)}>{t('edit')}</button>
        </div>
    )
}

export default CardOrganizer